/** Must equal PRE_SIGN_AUDIT_FIELD in functions/functions/ai/service/auditor/logic.js. */
export const PRE_SIGN_AUDIT_FIELD = 'auditMeta.lastCheckoutAuditId';

const [META_KEY, ID_KEY] = PRE_SIGN_AUDIT_FIELD.split('.');

/**
 * The check-out run that reviewed this note before it was signed, or null if none did.
 *
 * Cleared when the note is reopened: the marker describes one signing cycle, and the next signature
 * has not been reviewed until the auditor runs again.
 *
 * Kept apart from `audit`, which describes whichever run was last: a leader bulk-auditing a signed
 * note replaces that, and nothing would then say the note had been reviewed before signing.
 *
 * @param {Object} sessionActivity
 * @returns {string|null}
 */
export function getPreSignAuditId(sessionActivity) {
  return sessionActivity?.[META_KEY]?.[ID_KEY] ?? null;
} // getPreSignAuditId()

/**
 * @param {Object} sessionActivity
 * @returns {boolean}
 */
export function wasAuditedBeforeSigning(sessionActivity) {
  return !!getPreSignAuditId(sessionActivity);
} // wasAuditedBeforeSigning()
